
export function _setTOVisitorsList(state, responseData) {
    state.visitorsList = responseData
}
